"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareClass = exports.setSharePriceSchema = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const constants_1 = require("../constants");
const sharePriceSchema = yup
    .number()
    .required(constants_1.SHARE_PRICE_REQUIRED)
    .typeError(constants_1.SHARE_PRICE_VALID)
    .label("Share price")
    .min(0);
const sharePriceEffectiveDateSchema = yup.lazy(() => {
    const now = new Date();
    return yup
        .string()
        .required(constants_1.DATE_REQUIRED)
        .typeError(constants_1.DATE_VALID)
        .test("effectiveDate", constants_1.DATE_VALID, (effectiveDate) => (0, moment_1.default)(effectiveDate).isValid() && (0, mystake_common_sdk_1.getDateYear)(effectiveDate) > 1920)
        .test("testMaxDate", constants_1.DATE_NOT_FUTURE, (effectiveDate) => new Date(effectiveDate).getTime() <= now.getTime())
        .label("Effective Date");
});
exports.setSharePriceSchema = yup.object().shape({
    sharePrice: sharePriceSchema,
    effectiveFrom: sharePriceEffectiveDateSchema,
});
exports.shareClass = yup
    .string()
    .typeError(constants_1.SHARE_CLASS_INVALID)
    .required(constants_1.SHARE_CLASS_REQUIRED)
    .label("Share Class");
//# sourceMappingURL=SetSharePriceSchema.js.map